module.exports = __webpack_public_path__ + "img/stone-path.54a933b4.png";